package com.essntl.features.customfields.domain.model

import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel

data class CustomFieldsModel(
    val commissionType: CommissionType?,
    val commission: Double?,
    val source: String?,
    val category: CategoryModel?,
    val area: AreaModel?,
    val description: String?,
) {
    enum class CommissionType {
        Net,
        Gross,
    }

    val isEmpty
        get() = this.copy(
            commission = if (commission == null)
                null else if (commission.toInt() == 10)
                null else commission,
            commissionType = if (commission == null)
                null else if (commission.toInt() == 10)
                null else (commissionType ?: CommissionType.Gross),
            source = if (source.isNullOrEmpty()) null else source,
            description = if (description.isNullOrEmpty()) null else description,
        ) == empty

    companion object {
        val empty =
            CustomFieldsModel(
                commissionType = CommissionType.Gross,
                commission = 10.0,
                source = null,
                category = null,
                area = null,
                description = null,
            )
    }
}